import { Menu, Transition } from '@headlessui/react';
import type { ComponentProps } from 'react';
import { Fragment } from 'react';

import { MoreIcon } from '~components/icons/MoreIcon';
import { useLabel } from '~hooks/useLabels';
import { Button } from '~modules/media-library/view/Button';
import { TeaserMenuPanel } from '~modules/media-library/view/Teaser/TeaserMenuPanel';
import { isEmpty } from '~utils/object';

type TeaserMenuProps = Resolve<ComponentProps<typeof TeaserMenuPanel>>;

export function TeaserMenu(props: TeaserMenuProps) {
  const btnMediaLibraryActionMore = useLabel('btnMediaLibraryActionMore');
  if (!props.AssetActions || isEmpty(props.AssetActions)) return null;

  return (
    <Menu as="div" className="ml--teaser-menu relative inline-flex">
      {({ open }) => (
        <>
          <Menu.Button title={btnMediaLibraryActionMore} as={Button} variant="icon" active={open}>
            <MoreIcon />
          </Menu.Button>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="absolute right-0 bottom-full mb-2 min-w-40 origin-bottom-right outline-none z-20">
              <TeaserMenuPanel {...props} />
            </Menu.Items>
          </Transition>
        </>
      )}
    </Menu>
  );
}
